module.exports = __webpack_public_path__ + "static/scale-model-of-flummox'd-escape-rooms-in-hollywood-florida-3681d373668a8523b75cb49f3b6392cf.png";